export const get = (units, property) => 
  units?.Data?.[property]?.Value ?? null

export const uget = (units, property) =>
  units?.Data?.[property]?.UnformattedValue ?? null

// export const floorplan = (i,alternative) =>{
//   console.log(i,"iiiiiii")
//  return i?.Gallery?.Floorplan?.UrlThumbnail ?? alternative
// }
//for getting D images !
export const floorplan = (i,alternative) =>{
  
 return i?.Gallery?.Floorplan?.Url ?? alternative
}

export const rent = (i) => 
  uget(i,'SalesTypeID') === 103

export const getMoveInDate = (units, property) => {
  return uget(units, property);
}

export const getId = (units) => {
  return units?.UnitID ?? "";
};

// export const getImages = (unit, floorplan = true) => {
//   const gallery = unit?.Gallery?.ListOfPhotos ?? [];
//   console.log(gallery,"jsjs")
//   if (!floorplan) {
//     return gallery.map((i) => ({ url: i?.Url })).slice(1);
//   }
//   return gallery.map((i) => ({ url: i?.Url }));
// }
// export const getImages = (unit) => {
//   const gallery = unit?.Gallery?.ListOfPhotos ?? [];

//   // Separate the types
//   const forsideImage = gallery.filter((i) => i.Description === "Forsidebillede");
//   const floorplans = gallery.filter((i) => i.IsFloorplan);
//   const others = gallery.filter(
//     (i) => i.Description !== "Forsidebillede" && !i.IsFloorplan
//   );

//   // Final ordered list: Forsidebillede → others → floorplans
//   const ordered = [...forsideImage, ...others, ...floorplans];

//   // Map to simple { url } objects for display
//   return ordered.map((i) => ({ url: i?.Url }));
// };
export const getImages = (unit, floorplan = true) => {
  const gallery = unit?.Gallery ?? {};
  const floorplans = Array.isArray(gallery.Floorplans) ? gallery.Floorplans : [];
  const photos = Array.isArray(gallery.ListOfPhotos) ? gallery.ListOfPhotos : [];

  // 1️⃣ Separate "Forsidebillede" and others
  const forsideImage = photos.filter((i) => i.Description === "Forsidebillede");
  const otherPhotos = photos.filter(
    (i) => i.Description !== "Forsidebillede" && !i.IsFloorplan
  );

  // 2️⃣ Include all floorplans (if any)
  let combined = [...forsideImage, ...otherPhotos];
  if (floorplan && floorplans.length > 0) {
    combined = [...floorplans, ...combined];
  }

  // 3️⃣ Return mapped URLs
  return combined.map((i) => ({
    url: i?.UrlOriginal || i?.Url,
  }));
};


export const getThumb = (i, floorplan = true) => {
  const gallery = i?.Gallery?.ListOfPhotos ?? [];
  if (!floorplan) {
    return gallery.map((i) => ({ url: i?.UrlThumbnail })).slice(1);
  }
  return gallery.map((i) => ({ url: i?.UrlThumbnail }));
}


export const s2c = (status) => {
  if ( status.toUpperCase() == 'LEDIG' )      return '#00FF0080'
  if ( status.toUpperCase() == 'TIL LEJE' )   return '#00FF0080'
  if ( status.toUpperCase() == 'UDLEJET' )    return '#FF000080'
  if ( status.toUpperCase() == 'RESERVERET' ) return '#FFA50080'
  return '#ababab'
}

const postfix  = '/md.'
const monetary = ' kr.'

export const formatters = {
  Index  : (j,_) => j + 1,
  Pris   : (i,x) => {
    const isRent   = x == 'Husleje'
    const isString = typeof uget(i,x) == 'string'
    const rent     = isString ? '-' : get(i,x) + monetary + postfix
    const price    = isString ? '-' : get(i,x) + monetary 
    return isRent ? rent : price
  },
  Status : (i,x) => s2c(get(i,'UnitStatusName')),
  Etage  : (i,x) => { 
    // clog( 'i', i, 'x', x ) 
    return get(i,x) == 'err' ? get(i,'Etage') + '. sal' : get(i,x)
  },
  Areal  : (i,x) => get(i,x) ? get(i,x) + ' m²' : '',
  Rooms  : (i,x) => get(i,x) + ' vær.',
  Else   : (i,x) => get(i,x)
}